import { CONSENT_SHEET } from '@aera/content/client';
import type { ClientConfig, Lang } from '@aera/schema';
import { useTranslation } from 'react-i18next';
import { Sheet } from '../components/ui.js';
import { DeleteRequest } from '../brief/DeleteRequest.js';
import { CrossBorderText, ProcessingText, consentVars, versionLine } from './ConsentText.js';

/** The privacy chip on every question screen opens the consent sheet again, with a way to ask for deletion. */
export function PrivacySheet({
  open,
  onClose,
  lang,
  config,
  onDeleteRequest,
}: {
  open: boolean;
  onClose: () => void;
  lang: Lang;
  config: ClientConfig;
  onDeleteRequest: () => Promise<unknown>;
}) {
  const { t } = useTranslation();
  const vars = consentVars(config);
  return (
    <Sheet open={open} onClose={onClose} title={t('privacy.title')}>
      <div className="space-y-6">
        <section>
          <h3 className="mb-2 text-[15px] font-semibold text-ink-2">{CONSENT_SHEET.processing.title[lang]}</h3>
          <ProcessingText lang={lang} vars={vars} />
        </section>
        <section>
          <h3 className="mb-2 text-[15px] font-semibold text-ink-2">{CONSENT_SHEET.crossBorder.title[lang]}</h3>
          <CrossBorderText lang={lang} vars={vars} llmMode={config.llmMode} />
        </section>
        <p className="text-[13px] text-ink-2">{versionLine(lang, config.consentVersion, vars)}</p>
        <div className="rounded-2xl bg-surface p-4 text-[14px] text-ink-2">
          <DeleteRequest lang={lang} onRequest={onDeleteRequest} />
        </div>
      </div>
    </Sheet>
  );
}
